<template>
  <div class="voyage-list">
    <VoyageSummaryCard
      v-for="voyage in filteredVoyages"
      :key="voyage.id"
      :voyage="voyage"
      :showAction="selectedVoyageId == voyage.id"
      @cardHover="onCardHover(voyage)"
      @cardLeave="onCardLeave"
    />
  </div>
</template>
  <script>
import { mapState } from "vuex";
import VoyageSummaryCard from "./components/VoyageSummaryCard.vue";
export default {
  name: "VoyageSuccess",
  components: {
    VoyageSummaryCard,
  },
  data: () => ({
    selectedVoyageId: null,
    enableAction: false,
    dialog: false,
    selectedVoyage: "",
  }),
  computed: {
    ...mapState("weatherRouting/voyagesModule", [
      "allVoyages",
      "filteredVoyages",
    ]),
  },
  methods: {
    onCardHover(voyage) {
      this.selectedVoyageId = voyage.id;
    },
    onCardLeave() {
      this.selectedVoyageId = null;
    },
  },
};
</script>
  
<style scoped>
.voyage-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0px 8px;
}
</style>